import { render, staticRenderFns } from "./guard.vue?vue&type=template&id=5156f734&scoped=true&"
import script from "./guard.vue?vue&type=script&lang=js&"
export * from "./guard.vue?vue&type=script&lang=js&"
import style0 from "./guard.vue?vue&type=style&index=0&id=5156f734&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5156f734",
  null
  
)

export default component.exports